import { render, staticRenderFns } from "./QueueSelect.vue?vue&type=template&id=0adaddf4&"
import script from "./QueueSelect.vue?vue&type=script&lang=js&"
export * from "./QueueSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports